import Vue from 'vue';

export default {
    async horizont() {
        const response = await Vue.axios.get('stranka/storitve/getNaborStoritevHorizonta?idTehnoloskaOsnova=44');
        return response.data.data;
    }
}